import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {from, Observable, of, throwError} from 'rxjs';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {iClient} from '../Model/ClientModel';
import {environment} from '../../environments/environment';
import {AuditedGroupPlanDetail, AuditedRepositoryPage} from '../Model/audited-repository.model';

export type PlanSearchScope = 'CLIENT' | 'GLOBAL';
export type BenefitDomain = 'DENTAL' | 'MEDICAL';

export interface EmailAutomationInitiationResponse {
  jobId?: number;
  status?: string;
  message?: string;
}

export interface EmailAutomationStatus {
  jobId: number;
  status: string | null;
  totalEmails: number;
  processedEmails: number;
  successfulEmails: number;
  failedEmails: number;
  failureDetails: string | null;
  completed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  constructor(private httpClient: HttpClient,
              private authService: AuthService,
              private router: Router) { }

  // Fetch data from the maxdeductible endpoint for pInsuranceForm
  getClientDetails(body?: any, params?: any, scope: PlanSearchScope = 'CLIENT',
                   domain: BenefitDomain = 'DENTAL'): Observable<any> {
    const benefitDomain: BenefitDomain =
      body?.benefitDomain === 'MEDICAL' || body?.domain === 'MEDICAL' || params?.domain === 'MEDICAL'
        ? 'MEDICAL'
        : domain;
    return this.authService.getPost(`${environment.coverageService}plan`, {
      ...body, benefitDomain
    }, {
      ...params,
      scope: scope === 'CLIENT' ? 'CLIENT' : 'GLOBAL',
      domain: benefitDomain
    });
  }

  // Fetch data from the coverages endpoint for insuranceProceduresForm
  getInsuranceProcedures(params?: any): Observable<any> {
    // Correctly calling the coverages API
    return this.authService.getP(`${environment.coverageService}coinsurance`, params);
  }
  submitInsuranceData(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.coverageService}maxdeductible` , body , params);
  }
  updateInsuranceData(body?:any, params?: any): Observable<any> {
    return this.authService.put(`${environment.coverageService}maxdeductible` , body , params);
  }
  submitcoverageData(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.coverageService}coinsurance` , body , params);
  }
  updatecoverageData(body?:any, params?: any): Observable<any> {
    return this.authService.put(`${environment.coverageService}coinsurance` , body , params);
  }
  // Appointment Info
  getPatientDetails(params?: any): Observable<any> {
    // Correctly calling the maxdeductible API
    return this.authService.getP(`${environment.coverageService}patient-info`, params);
  }
  submitProcedureData(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.patientService}patient` , body , params);
  }
  updateProcedureData(body?:any, params?: any): Observable<any> {
    return this.authService.put(`${environment.patientService}patient` , body , params);
  }

  getInsuranceQuentions(params?: any): Observable<any> {
    // Correctly calling the coverages API
    return this.authService.getP(`${environment.coverageService}office-question`, params);
  }
  // calling Co Insurances
  getCoinsurance(params?: any): Observable<any> {
    return this.authService.getP(`${environment.coverageService}coinsurance`, params);
  }
  submitCoinsuranceData(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.coverageService}coinsurance` , body , params);
  }
  updateCoinsuranceData(body?:any, params?: any): Observable<any> {
    return this.authService.put(`${environment.coverageService}coinsurance` , body , params);
  }
  //calling ORTHO
  getOrtho(params?: any): Observable<any> {
    return this.authService.getP(`${environment.coverageService}ortho`, params);
  }
  submitOrthoData(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.coverageService}ortho` , body , params);
  }
  updateOrthoData(body?:any, params?: any): Observable<any> {
    return this.authService.put(`${environment.coverageService}ortho` , body , params);
  }
  //Calling History
  getHistory(params?: any): Observable<any> {
    return this.authService.getP(`${environment.patientService}patient`, params);
  }
  submitHistoryData(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.patientService}patient` , body , params);
  }
  updateHistoryData(body?:any, params?: any): Observable<any> {
    return this.authService.put(`${environment.patientService}patient`, body, params);
  }
  // Combined post
  submitCombinedInsurance(body?: any, params?: any): Observable<any> {
    const benefitDomain: BenefitDomain =
      body?.benefitDomain === 'MEDICAL' || params?.domain === 'MEDICAL'
        ? 'MEDICAL' : 'DENTAL';
    return this.authService.put(`${environment.coverageService}plan`, {
      ...body, benefitDomain
    }, { ...params, domain: benefitDomain });
  }
  // Filter Assigned Date
  filterDate(params?: any): Observable<any> {
    return this.authService.getP(`${environment.patientService}patient`, params);
  }

  // calling Active Coverage
  // getActiveCoverage(params?: any): Observable<any> {
  //   return this.authService.getP(`coverage-dev/active-coverage`, params);
  // }
  // submitActiveCoverageData(body?:any, params?: any): Observable<any> {
  //   return this.authService.postP(`${`coverage-dev/active-coverage`}` , body , params);
  // }
  // updateActiveCoverageData(body?:any, params?: any): Observable<any> {
  //   return this.authService.put(`${`coverage-dev/active-coverage`}` , body , params);
  // }
  checkFieldsStatus() {
    return ('/api/fields-status'); // Replace with your actual API endpoint
  }
  //get UserWork Area Lisiting
  getUserWorkArea(params?: any): Observable<any> {
    // Correctly calling the coverages API
    return this.authService.getP(`${environment.patientService}patient`, params);
  }

  updateUserWorkAreaPatient(body?:any, params?: any): Observable<any> {
    return this.authService.patchP(`${environment.patientService}patient`, body, params);
  }
  updateTime(params?: any): Observable<any> {
    return this.authService.patchB(`${environment.patientService}patient`, params);
  }
  // getExportFile(params?: any): Observable<any> {
  //   // Correctly calling the Reports API
  //   return this.authService.getP(`report/report`, params);
  // }
  getVerifyProcedureData(params?: any): Observable<any> {
    // Correctly calling the Verification API
    return this.authService.getP(`${environment.coverageService}verification`, params);
  }
  verifyProcedureData(body?:any, params?: any): Observable<any> {
    return this.authService.postP(`${environment.coverageService}verification` , body , params);
  }
  updateVerifyProcedureData(body?:any, params?: any): Observable<any> {
    return this.authService.put(`${environment.coverageService}verification` , body , params);
  }

  submitAuditSubmission(body?: any, params?: any): Observable<any> {
    return this.authService.postP(
      `${environment.coverageService}audit/submissions`,
      body,
      params
    );
  }

  /** 404 means there is no active change request for this patient and domain. */
  getAuditChangeRequestsForPatient(patientId: number, clientId: number,
                                   benefitDomain: BenefitDomain): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit/change-requests/patients/${patientId}`,
      { clientId, benefitDomain }
    );
  }

  getAuditQueue(params?: any): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit`,
      params
    );
  }

  getAuditMetrics(params?: any): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit/metrics`,
      params
    );
  }

  assignAuditAuditor(auditId: number, body: any, params?: any): Observable<any> {
    return this.authService.put(
      `${environment.coverageService}audit/${auditId}/assignment`,
      body,
      params
    );
  }

  getAuditDetail(auditId: number, params?: any): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit/${auditId}`,
      params
    );
  }

  getAuditQuestions(auditId: number, params?: any): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit/${auditId}/questions`,
      params
    );
  }

  saveAuditReviewMetadata(auditId: number, body: any, params?: any): Observable<any> {
    return this.authService.put(
      `${environment.coverageService}audit/${auditId}/review-metadata`,
      body,
      params
    );
  }

  createAuditStorageBatch(body: {
    clientId: number;
    name: string;
    serviceType: 'AUDIT';
    businessDate: string;
  }): Observable<any> {
    return this.authService.postP(
      `${environment.patientService}storage/batches`,
      body
    );
  }

  uploadAuditFaxback(batchId: string, clientId: number, file: File): Observable<any> {
    const body = new FormData();
    body.append('file', file, file.name);
    const safeName = (file.name || 'faxback.pdf').replace(/[\\/]/g, '_');
    body.append('relativePath', `Faxback/${safeName}`);

    // Multipart form-data must use the browser-generated Content-Type boundary.
    return this.authService.postAbsoluteFormData(
      `${environment.apiRoot}${environment.patientService}storage/batches/${encodeURIComponent(batchId)}/files`,
      body,
      { clientId, extractZip: false, replaceExisting: false }
    );
  }

  getAuditFaxbackContent(batchId: string, fileId: number, clientId: number): Observable<Blob> {
    // Fetch with Authorization; a direct hyperlink would not send the Bearer token.
    return this.authService.getPDFView(
      `${environment.patientService}storage/batches/${encodeURIComponent(batchId)}/files/${fileId}/content`,
      { clientId },
      'blob'
    );
  }

  startAudit(auditId: number, body: any, params?: any): Observable<any> {
    return this.authService.postP(
      `${environment.coverageService}audit/${auditId}/start`,
      body,
      params
    );
  }

  reviewAuditQuestion(auditId: number, questionId: number, body: any, params?: any): Observable<any> {
    return this.authService.put(
      `${environment.coverageService}audit/${auditId}/questions/${questionId}`,
      body,
      params
    );
  }

  requestAuditChanges(auditId: number, body: any, params?: any): Observable<any> {
    return this.authService.postP(
      `${environment.coverageService}audit/${auditId}/request-changes`,
      body,
      params
    );
  }

  passAudit(auditId: number, body: any, params?: any): Observable<any> {
    return this.authService.postP(
      `${environment.coverageService}audit/${auditId}/pass`,
      body,
      params
    );
  }

  publishAudit(auditId: number, body: any, params?: any): Observable<any> {
    return this.authService.postP(
      `${environment.coverageService}audit/${auditId}/publish`,
      body,
      params
    );
  }

  getAuditTimeline(auditId: number, params?: any): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit/${auditId}/timeline`,
      params
    );
  }

  getAuditRevisions(auditId: number, params?: any): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit/${auditId}/revisions`,
      params
    );
  }

  getAuditRevision(auditId: number, revisionId: number, params?: any): Observable<any> {
    return this.authService.getP(
      `${environment.coverageService}audit/${auditId}/revisions/${revisionId}`,
      params
    );
  }

  resubmitAudit(auditId: number, body: any, params?: any): Observable<any> {
    return this.authService.postP(
      `${environment.coverageService}audit/${auditId}/resubmit`,
      body,
      params
    );
  }
  // materialTrackerXlsFile(params: any) {    return this.api.getDirectForExecution(`${API_Route.materialTrackerXlsFile}`, params);}

  getExportFile(body?: any, params?: any): Observable<any> {
    // Correctly calling the Reports API
    return this.authService.getPDF(`${environment.reportService}patientreport`,body,  params);
  }
  // Bulk Export
  getBulkExport(body?: any, params?: any): Observable<any> {
    return this.authService.getPDF(`${environment.reportService}patientreport/batch`, body,  params);
  }
  // Read-only, client-scoped repository of 100%-passed audited group plans.
  getAuditedRepository(params: {
    clientId: number;
    page: number;
    size: number;
    groupNumber?: string;
    planName?: string;
    benefitDomain?: BenefitDomain;
  }): Observable<AuditedRepositoryPage> {
    return this.authService.getP(
      `${environment.coverageService}audit/repository`,
      params
    );
  }

  getAuditedRepositoryDetail(groupId: number, clientId: number): Observable<AuditedGroupPlanDetail> {
    return this.authService.getP(
      `${environment.coverageService}audit/repository/${groupId}`,
      {clientId}
    );
  }

  // Legacy patient repository API: retained for any other callers.
  // Repo Listing
  getRepoLisitng(params?: any): Observable<any> {
    return this.authService.getP(`${environment.patientService}patient`, params);
  }
  // Hmo Listing
  getHmoListing(params?: any): Observable<any> {
    // Correctly calling the coverages API
    return this.authService.getP(`${environment.batchJob}hmo`, params);
  }

  getHmoPayerListing(params?: any): Observable<any> {
    // Correctly calling the coverages API
    return this.authService.getP(`${environment.batchJob}hmo`, params);
  }

  hmoUpload(data,params): Observable<any> {
    return this.authService.postD(`${environment.batchJob}hmo`, data, params);
  }

  filterHmo(params?: any): Observable<any> {
    return this.authService.getP(`${environment.batchJob}hmo`, params);
  }

  searchHmo(params?:any): Observable<any> {
    return this.authService.getP(`${environment.batchJob}hmo`, params);
  }

  // group search lisitng
  getGroupSearch(pathParams: any, clientId: any, scope: PlanSearchScope = 'CLIENT', domain: BenefitDomain = 'DENTAL'): Observable<any> {
   const path = Object.values(pathParams).join('/');
    return this.authService.getP(
      `${environment.coverageService}group/search/${path}/contains`, { clientId, scope, domain }
    );
  }

  saveVerificationTime(body?: any, params?: any): Observable<any> {
  return this.authService.postP(
    `${environment.patientService}patient`,
    body,
    params
  );
}

  // extractor
  runExtractor( file: File | null , clientId: number, officeId: number, payerName: string, date: string | null, reportMode?: 'single' | 'multiple'): Observable<any> {
  const formData = new FormData();

  if (file) {
    formData.append('file', file);
  }

   const params: {
    clientId: number;
    officeId: number;
    payerName: string;
    date?: string;
    reportMode?: 'single' | 'multiple';
  } = {
    clientId,
    officeId,
    payerName
  };

  if (date) {
    params.date = date; // example: 2026-07-07
  }

  if (reportMode) {
    params.reportMode = reportMode;
  }

  return this.authService.postAbsoluteFormData(
    'http://localhost:8082/extractor/extractor',
    formData,
    params
  );
}

runPasting( file: File | null , clientId: number, payerName: string, date: string | null, reportMode?: 'single' | 'multiple'): Observable<any> {
  const formData = new FormData();

  if (file) {
    formData.append('file', file);
  }

   const params: {
    clientId: number;
    payerName: string;
    date?: string;
    reportMode?: 'single' | 'multiple';
  } = {
    clientId,
    payerName
  };

  if (date) {
    params.date = date; // example: 2026-07-07
  }

  if (reportMode) {
    params.reportMode = reportMode;
  }

  return this.authService.postAbsoluteFormData(
    'http://localhost:8082/extractor/extractor',
    formData,
    params
  );
}

  runEmailAutomation(
    clientId: number,
    username: string,
    password: string,
    date: string
  ): Observable<EmailAutomationInitiationResponse> {
    const params = {
      clientId,
      includeSummaryReport: true,
      username,
      password,
      date
    };

    return this.authService.postAbsolute(
      'http://localhost:8082/extractor/extractor/eod-report',
      null,
      params
    );
  }

  getEmailAutomationStatus(jobId: number): Observable<EmailAutomationStatus> {
    return this.authService.getAbsolute(
      `http://localhost:8082/extractor/extractor/eod-report/status/${jobId}`
    );
  }
}

